import { DashboardIFrame } from "components/organisms/DashboardIFrame";

const Pipeline = () => {
  return <DashboardIFrame page="pipeline" />;
};

export { Pipeline };
